import { createContext, useContext } from 'react';

const TargetsContext = createContext();

export const TargetsContextProvider = ({ children }) => {
    const targets = {
        maternity: 'Maternity',
        men: 'Men',
        unisex: 'Unisex',
        women: 'Women'
    };
    return (
        <TargetsContext.Provider value={targets}>
            {children}
        </TargetsContext.Provider>
    );
};

export const useTargetsContext = () => useContext(TargetsContext);

export default TargetsContext;
